<template>
  <div class="card" :class="{ 'card--highlight': highlight, 'card--list': appearance === 'list' }">
    <template v-if="skeleton">
      <div class="card__specialist">
        <div class="card__specialist__info">
          <p class="card__specialist__title skeleton" style="width: 150px; max-width: 100%; height: 20px;" />
        </div>
        <div class="card__specialist__avatar skeleton" style="border: none" />
      </div>

      <div class="card__info">
        <div class="card__info__item">
          <h4 class="card__info__title skeleton" style="width: 100px; max-width: 100%; height: 15px;" />
          <p class="card__info__value skeleton" style="width: 80px; max-width: 100%; height: 15px;" />
        </div>
        <div class="card__info__item">
          <h4 class="card__info__title skeleton" style="width: 100px; max-width: 100%; height: 15px;" />
          <p class="card__info__value skeleton" style="width: 80px; max-width: 100%; height: 15px;" />
        </div>
      </div>

      <div class="card__menu">
        <button class="card__action skeleton" />
        <button class="card__subaction" />
      </div>
    </template>
    <template v-else>
      <div class="card__specialist">
        <div class="card__specialist__info">
          <router-link class="card__specialist__name" :to="`/specialists/profile/${ specialistId }`" v-if="specialistId">
            {{ spacialistName }}
          </router-link>
          <div class="card__specialist__name" v-else>
            {{ spacialistName }}
          </div>
          <p class="card__specialist__title">
            {{ specialistTitle }}
          </p>
        </div>
        <img class="card__specialist__avatar" :src="specialistAvatar" v-if="specialistId" />
        <img class="card__specialist__avatar" src="@/assets/images/person-icon.png" v-else />
      </div>

      <div class="card__info">
        <div class="card__info__item" v-for="(cardItem, index) of cardList" :key="index">
          <h4 class="card__info__title">
            {{ cardItem.title }}
          </h4>
          <i class="card__info__icon fas" :class="{ [ cardItem.icon ]: true }" />
          <p class="card__info__value" @click="(index == 0 ? $emit('clickSubAction') : '')" :style="{color: (index == 0 ? '#3c59a6' : 'initial'), cursor: 'pointer'}">
            {{ cardItem.value }}
          </p>
        </div>
      </div>

      <div class="card__menu">
        <button
          class="card__action"
          :class="{
            'card__action--gradient'   : cardActionType === 'gradient',
            'card__action--primary'    : cardActionType === 'primary',
            'card__action--processing' : cardActionType === 'processing',
            'card__action--secondary'  : cardActionType === 'secondary',
            'card__action--danger'  : cardActionType === 'danger',
          }"
          @click="$emit('clickAction')"
        >
          <i class="fas fa-sync fa-spin" v-if="cardActionType === 'processing'"></i>
          <template v-else>{{ cardActionValue }}</template>
        </button>

        <button style="display: none;"
          class="card__subaction"
          :class="{
            'card__subaction--danger'    : cardSubActionType === 'danger',
            'card__subaction--gray'      : cardSubActionType === 'gray',
            'card__subaction--secondary' : cardSubActionType === 'secondary',
            'card__subaction--danger' : cardSubActionType === 'danger',
            }"
          @click="$emit('clickSubAction')"
        >
          {{ cardSubActionValue }}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: [
    'appearance',
    'highlight',
    'skeleton',

    'cardActionType',
    'cardActionValue',
    'cardSubActionType',
    'cardSubActionValue',
    'cardList',

    'specialistId',
    'spacialistName',
    'specialistTitle',
    'specialistAvatar',
  ]
}
</script>

<style lang="scss" scoped>
.card {
  background: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
  padding: 20px 20px 5px 20px;
  display: flex;
  flex-direction: column;
  height: initial !important;
  width: 100%;

  @include media-breakpoint-up(lg) {
    &--list {
      align-items: center;
      flex-direction: row;
      max-width: 100%;
      padding: 15px;
    }
  }

  &--highlight {
    border-color: #00cd98;
  }

  &__specialist {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;

    &__info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: calc(100% - 80px);
    }

    &__name {
      color: $color-gray;
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      text-decoration: none;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 100%;
      transition: 200ms color;

      &:not(div):hover {
        color: $color-primary;
      }
    }

    &__title {
      color: $color-secondary;
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
      margin-top: 5px;
      white-space: nowrap;
    }

    &__avatar {
      border: 1px solid $color-light-gray;
      border-radius: 9999px;
      height: 60px;
      user-select: none;
      width: 60px;
      object-fit: cover;
    }
  }

  &--highlight &__specialist__avatar {
    border-color: #00cd98;
  }

  @include media-breakpoint-up(lg) {
    &--list &__specialist {
      justify-content: flex-start;
      margin-bottom: 0;
      margin-right: auto;
      padding-right: 30px;

      &__info {
        margin-left: 20px;
        order: 2;
      }

      &__avatar {
        order: 1;
      }
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    &__item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &__title,
    &__value {
      color: $color-gray;
      font-family: 'Roboto';
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
      white-space: nowrap;
    }

    &__icon {
      color: $color-gray;
      display: none;
      font-size: 16px;
      margin-right: 10px;
    }

    &__value {
      font-weight: 500;
    }
  }

  @include media-breakpoint-up(lg) {
    &--list &__info {
      flex-direction: row;
      margin-bottom: 0;
      margin-right: 20px;

      &__item {
        align-items: center;
        margin-bottom: 0;
        margin-right: 30px;
      }

      &__title {
        display: none;
      }

      &__icon {
        display: block;
      }
    }
  }

  &__menu {
    display: flex;
    flex-direction: column;
  }

  &__action,
  &__subaction {
    background: transparent;
    border: 0;
    border-radius: 9999px;
    cursor: pointer;
    font-family: 'DIN Pro';
    font-size: 13px;
    line-height: 1;
    outline: none;
    padding: 10px 30px;
    text-align: center;
    white-space: nowrap;
    transition: 100ms opacity;
  }

  &__action {
    border: 1px solid transparent;
    font-weight: 500;

    &--gradient {
      background: $gradient-nexyo;
      border: none;
      color: #ffffff;

      &:hover {
        opacity: 0.8;
      }

      &:active {
        opacity: 1;
      }
    }

    &--primary {
      background: $color-primary;
      color: #ffffff;
      cursor: default !important;
    }

    &--processing {
      background: $color-warning;
      color: $color-gray;
      cursor: default !important;
    }

    &--secondary {
      background: #00cd98;
      color: #ffffff;

      &:hover {
        background: transparent;
        border-color: #00cd98;
        color: #00cd98;
      }
    }
    
    &--danger {
      background: $color-danger;
      color: #ffffff;
      cursor: default !important;
    }
  }

  &__subaction {
    font-weight: 400;

    &--danger {
      color: #fa0a26;
    }

    &--gray {
      color: rgba(55, 52, 53, 0.3);
      cursor: default !important;
    }

    &--secondary {
      color: $color-secondary;
      font-weight: 500;
    }
  }

  @include media-breakpoint-up(lg) {
    &--list &__menu {
      flex-direction: row;
      width: 350px;
    }

    &--list &__action {
      flex: 1;

      &--secondary {
        background: #00cd98;
        font-weight: 500;

        &:hover {
          background: transparent;
        }
      }
    }

    &--list &__subaction {
      margin-left: 20px;

      &--danger {
        background: #fa0a26;
        border: 1px solid transparent;
        color: #ffffff;

        &:hover {
          background: transparent;
          border-color: #fa0a26;
          color: #fa0a26;
        }
      }

      &--gray {
        display: none;
      }

      &--secondary {
        background: transparent;
        border: 1px solid #00cd98;
        color: #00cd98;
        font-weight: 500;

        &:hover {
          background: #00cd98;
          border-color: transparent;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
